import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { fetchAutonomo } from "screens/perfilAutonomo/api/getAutonomo";
import PerfilSkeleton from "screens/perfilAutonomo/perfil/skeleton.component";
import * as IconsSVG from "../../assets/iconsSVG";
import * as S from "./styles";
import ModalBlock from "./modal-block";
import Contacts from "./contacts";

function BlockSellit() {
  const [openModal, setOpenModal] = useState<string | null>(null);

  const { username } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const { data: user, isLoading, isError } = fetchAutonomo(username);

  const router = useHistory();

  const handleOpenModal = () => {
    const regionalMap = new Map([
      ["00000000-0000-0000-0000-000000000002", "contatoRJ"],
      ["00000000-0000-0000-0000-000000000003", "contatoRS"],
    ]);

    const empresaMap = new Map([
      ["00000000-0000-0000-0000-000000000002", "contatoVivazSp"],
      ["00000000-0000-0000-0000-000000000003", "contatoVivazVendas"],
    ]);

    const regionalId = user?.autonomoResponse?.idRegional;
    const empresaId = user?.autonomoResponse?.idEmpresaVenda;

    const regionalType = regionalMap.get(regionalId);
    if (regionalType) {
      setOpenModal(regionalType);
      return;
    }

    const empresaType = empresaMap.get(empresaId) ?? "contatoSellerSp";
    setOpenModal(empresaType);
  };

  const handleCloseModal = () => {
    setOpenModal(null);
  };

  useEffect(() => {
    const _div = document.getElementById("parentContainer");
    if (_div) _div.click();
  }, []);

  const handleOpenLink = (url: string) => {
    window.open(url, "_blank");
  };

  const renderModalContent = () => {
    switch (openModal) {
      case "contatoSellerSp":
        return Contacts.SellerSp;
      case "contatoVivazSp":
        return Contacts.VivazSp;
      case "contatoVivazVendas":
        return Contacts.VivazVendas;
      case "contatoRJ":
        return Contacts.Rj;
      case "contatoRS":
        return Contacts.Sul;
      default:
        return <></>;
    }
  };

  if (
    isError ||
    (typeof user?.autonomoResponse?.idStatusAutonomo === "number" &&
      user?.autonomoResponse?.idStatusAutonomo !== 1)
  ) {
    router.push("/");
  }

  if (isLoading) {
    return <PerfilSkeleton />;
  }

  return (
    <S.ParentContainer id="parentContainer">
      {/* Saudação */}
      <S.Header>
        <S.Greeting>Olá, {user?.autonomoResponse?.nome}!</S.Greeting>
      </S.Header>

      {/* Ações */}
      <S.ActionsContainer>
        <div>
          <S.ActionsTitle>O que você gostaria de fazer?</S.ActionsTitle>
          <S.ActionsCarousel>
            <S.ActionButton
              onClick={() => handleOpenLink("https://outlook.office.com/mail")}
            >
              <S.LockedIcon>
                <IconsSVG.MailBlockIcon color="#2D5BFF" />
              </S.LockedIcon>
              Webmail
            </S.ActionButton>
            <S.ActionButton
              onClick={() =>
                handleOpenLink(
                  "https://academiaseller.conexaoseller.com.br/auth/signin"
                )
              }
            >
              <S.LockedIcon>
                <IconsSVG.AcademiaBlockIcon color="#2D5BFF" />
              </S.LockedIcon>
              Academia Seller
            </S.ActionButton>
            <S.ActionButton onClick={handleOpenModal}>
              <S.LockedIcon>
                <IconsSVG.AvatarIcon color="#2D5BFF" />
              </S.LockedIcon>
              Contato de Pessoas e Organização
            </S.ActionButton>
          </S.ActionsCarousel>
        </div>

        {/* Sistema Bloqueado */}
        <S.SystemBlocked>
          <S.LockedIcon>
            <IconsSVG.CadeadoIcon color="#F43636" />
          </S.LockedIcon>
          <h2>SISTEMA BLOQUEADO</h2>
        </S.SystemBlocked>
      </S.ActionsContainer>

      {openModal && (
        <ModalBlock title="Entre em contato" onClose={handleCloseModal}>
          {renderModalContent()}
        </ModalBlock>
      )}
    </S.ParentContainer>
  );
}

export default BlockSellit;
